(function ($) {

  /*
   * detect IE
   * returns version of IE or false, if browser is not Internet Explorer
   */
  var detectIE = function () {

    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      var rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  };

  var ieVersion = detectIE();
  if (ieVersion !== false) {
    var browser = ieVersion >= 12 ? 'edge' : 'ie';

    $('body')
        .addClass(browser)
        .addClass(browser + '-' + ieVersion);
  }
  else {
    $('body').addClass('no-ie');
  }

  $(document).ready(function () {

    /*
     * Flex box polyfill for IE9 an lower - From https://github.com/jonathantneal/flexibility
     */
    if (ieVersion && ieVersion <= 9) {
      flexibility(document.body);
    }

  });

  $(window).resize(function () {

  });

})(jQuery);


// tartaucitron.js
tarteaucitron.init({
    "privacyUrl": "", /* Privacy policy url */
    "hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
    "cookieName": "tarteaucitron", /* Cookie name */
    "orientation": "top", /* Banner position (top - bottom) */
    "showAlertSmall": false, /* Show the small banner on bottom right */
    "cookieslist": true, /* Show the cookie list */
    "adblocker": false, /* Show a Warning if an adblocker is detected */
    "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
    "highPrivacy": false, /* Disable auto consent */
    "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */
    "removeCredit": true, /* Remove credit link */
    "moreInfoLink": true, /* Show more info link */
    "useExternalCss": false, /* If false, the tarteaucitron.css file will be loaded */
    "readmoreLink": "/politique-de-confidentialite" /* Change the default readmore link */
});

tarteaucitron.user.gtagUa = 'UA-XXXXXXXX-X';
tarteaucitron.user.gtagMore = function () { /* add here your optionnal gtag() */ };
(tarteaucitron.job = tarteaucitron.job || []).push('gtag');

// Add tartaucitron.js link ckeditor in a ckeditor hyperlink with #tac-link id
// attribute
if (document.querySelector('#tac-link')) {
  document.querySelector('#tac-link').setAttribute('href', 'javascript:tarteaucitron.userInterface.openPanel();');
}



